export default {
  '_test_field_code': [{title: "테스트페이지"}],
  'workplace-insider': [{title: "사업장 현황"}, {title: "직영사업장"}],
  'workplace-subcontract': [{title: "사업장 현황"}, {title: "도급·용역·위탁 사업장"}],
  'workplace-ordering': [{title: "사업장 현황"}, {title: "발주 사업장"}],
  'facility': [{title: "사업장 현황"}, {title: "시설물"}],
  'warehouse': [{title: "사업장 현황"}, {title: "창고"}],
  'bridge': [{title: "중대시민재해 시설물 현황"}, {title: "공중이용시설 현황"}, {title: "교량"}],
  'retaining-wall': [{title: "중대시민재해 시설물 현황"}, {title: "공중이용시설 현황"}, {title: "옹벽"}],
  'dike': [{title: "중대시민재해 시설물 현황"}, {title: "공중이용시설 현황"}, {title: "제방"}],
  'government-building': [{title: "중대시민재해 시설물 현황"}, {title: "공중이용시설 현황"}, {title: "청사"}],
  'complex-facility': [{title: "중대시민재해 시설물 현황"}, {title: "공중이용시설 현황"}, {title: "복합시설"}],
  'public-transportation': [{title: "중대시민재해 현황"}, { title: "공중교통수단"}],
  'workplace-material': [{title: "사업장/시설물 현황"}, { title: "원료·제조물 사업장"}],
  'facility-public': [{title: "중대시민재해 현황"}, { title: "공중(다중)이용시설"}],
}
